'use strict';

import { NgModule } from '@angular/core';
import { IconComponent } from './component';

@NgModule({
  declarations: [IconComponent],
  exports     : [IconComponent]
})
export class LKIcon {
}
